import React, { useState } from "react";

function ServiceDropdown({ title, lead, children }) {
  const [open, setOpen] = useState(false);
  const [number, ...titleParts] = title.split(" - ");
  const serviceTitle = titleParts.join(" - ");

  return (
    <article
      className={`service-card${open ? " is-open" : ""}`}
      style={{
        background: "#fff",
        borderRadius: 10,
        marginBottom: 24,
        boxShadow: "0 2px 12px rgba(26,35,126,0.07)",
        overflow: "hidden",
      }}
    >
      <button
        type="button"
        className="service-card-trigger"
        onClick={() => setOpen((current) => !current)}
        aria-expanded={open}
        style={{
          width: "100%",
          background: open ? "#e3eafc" : "#fff",
          border: "none",
          padding: "20px 28px",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          cursor: "pointer",
          fontSize: "1.18rem",
          fontWeight: 700,
          color: "#1a237e",
          textAlign: "left",
        }}
      >
        <span className="service-card-heading">
          <span className="service-card-number">{number.padStart(2, "0")}</span>
          <span>
            <span className="service-card-title">{serviceTitle}</span>
            <span className="service-card-lead">{lead}</span>
          </span>
        </span>
        <span className="service-card-affordance">{open ? "Close" : "Read more"}</span>
        <span
          className="service-card-chevron"
          style={{
            fontSize: "1.4rem",
            transition: "transform 0.2s",
            transform: open ? "rotate(180deg)" : "rotate(0deg)",
          }}
        >
          ▼
        </span>
      </button>
      {open && <div className="service-card-details">{children}</div>}
    </article>
  );
}

export default ServiceDropdown;
